import { apiFetch } from './client';
import { parseJsonResponse } from './parseResponse';

export type LandingModule = {
  icon: string;
  label: string;
};

export type LandingSettings = {
  company_name: string;
  phone: string;
  whatsapp: string;
  whatsapp_href?: string;
  email: string;
  address: string;
  working_hours: string;
  facebook_url: string;
  instagram_url: string;
  twitter_url: string;
  linkedin_url: string;
  tiktok_url: string;
  youtube_url: string;
  footer_copyright: string;
  modules: LandingModule[];
  modules_count?: number;
};

export type UpdateLandingSettingsPayload = Omit<LandingSettings, 'whatsapp_href' | 'modules_count'>;

export async function fetchLandingSettings(): Promise<
  { ok: true; data: LandingSettings } | { ok: false; message: string; unauthorized?: boolean }
> {
  const res = await apiFetch('/platform/landing-settings');
  const out = await parseJsonResponse<LandingSettings>(res);
  if (out.ok === false) {
    return { ok: false, message: out.message, unauthorized: out.unauthorized };
  }
  return { ok: true, data: out.data };
}

export async function updateLandingSettings(
  payload: UpdateLandingSettingsPayload,
): Promise<
  { ok: true; data: LandingSettings } | { ok: false; message: string; unauthorized?: boolean }
> {
  const res = await apiFetch('/platform/landing-settings', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const out = await parseJsonResponse<LandingSettings>(res);
  if (out.ok === false) {
    return { ok: false, message: out.message, unauthorized: out.unauthorized };
  }
  return { ok: true, data: out.data };
}
